package ui.app.assign.detail.definition

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import api.ResourceType
import compose.assets.Svg
import compose.assets.svg.Edit
import compose.assets.svg.Keyboard
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_bottom_detail__www_app_pick_label
import ssoft.frontend.generated.resources.layer_bottom_detail__www_keyboard_label
import ssoft.frontend.generated.resources.layer_bottom_detail__www_keyboard_visible_label
import tools.GlobalObjectShare
import tools.rememberString
import ui.app.assign.detail.AppDetailScope
import ui.resource.ResourceListingArgs
import ui.widget.IconicSwitch
import ui.widget.Space


@Composable
fun AppDetailScope.AppDefOfWwwEmbedded(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwEmbedded
) {
    Row {
        Column {
            DefaultFields(wrapper)
        }
        Space(16.dp)
        Column {
            WebAppPicker(wrapper, nnvl)
            Space(24.dp)
            ViewField(wrapper, nnvl)
        }
    }
    Space(64.dp)
}


@Composable
private fun AppDetailScope.ViewField(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwEmbedded
) {
    Card {
        Column(
            Modifier.padding(16.dp)
                .width(256.dp)
        ) {
            Text(Res.string.layer_bottom_detail__www_keyboard_label.rememberString())
            Space(8.dp)
            Card(colors = CardDefaults.cardColors(MaterialTheme.colorScheme.inverseSurface)) {
                Row(Modifier
                    .fillMaxWidth()
                    .clip(CardDefaults.shape)
                    .clickable(wrapper.canEdit) { nnvl.keyboard.set(!nnvl.keyboard.state) }
                    .padding(8.dp)) {
                    Icon(
                        imageVector = Svg.Keyboard,
                        contentDescription = null,
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                    Space(8.dp)
                    Text(
                        text = Res.string.layer_bottom_detail__www_keyboard_visible_label.rememberString(),
                        modifier = Modifier
                            .weight(1F)
                            .align(Alignment.CenterVertically)
                    )
                    Space(8.dp)
                    IconicSwitch(
                        checked = nnvl.keyboard.state,
                        onCheckedChange = { nnvl.keyboard.set(it) },
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                }
            }
        }
    }
}

@Composable
private fun AppDetailScope.WebAppPicker(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwEmbedded,
) {

    val imagePickerKey = remember(args.appId) {
        "WebAppPicker:${args.appId}"
    }

    GlobalObjectShare.Consumer(imagePickerKey)

    fun openResourcePicker() {
        GlobalObjectShare.launchImagePicker(
            key = imagePickerKey,
            nav = nav,
            args = ResourceListingArgs(
                companyId = args.companyId,
                restrictionType = ResourceType.WWW_APP.mask,
                restrictionCanIgnoreAspectRatio = true
            )
        ) {
            it.firstOrNull()?.apply {
                nnvl.zip.set(id)
                nnvl.name.set(name)
            }
        }
    }

    Card {
        Box {
            Column(Modifier.padding(16.dp)) {
                Text(Res.string.layer_bottom_detail__www_app_pick_label.rememberString())
                Space(8.dp)
                Card(Modifier.width(256.dp)) {
                    Card(
                        onClick = { openResourcePicker() },
                        colors = CardDefaults.cardColors(MaterialTheme.colorScheme.inverseSurface)
                    ) {
                        Row {
                            Text(
                                text = nnvl.name.state,
                                style = MaterialTheme.typography.titleMedium,
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis,
                                modifier = Modifier.weight(1F)
                                    .padding(horizontal = 8.dp)
                                    .align(Alignment.CenterVertically)
                            )
                            if (wrapper.canEdit) {
                                FloatingActionButton(
                                    shape = CardDefaults.shape,
                                    onClick = { openResourcePicker() },
                                    modifier = Modifier.align(Alignment.CenterVertically)
                                ) {
                                    Icon(
                                        imageVector = Svg.Edit,
                                        contentDescription = null
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }

    }
}
